import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'

const useGetPaymentListData = () => {
  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 50,
    search: true,
    store_filter: '',
    supplier_filter: '',
    sort_by: 'schedule_payment_date/1',
  }

  const {filters, onSearch, onPageChange, onSortingChange, setMultipleFilters} = useFilters(
    initialFilters,
    {
      sortType: 'number',
    }
  )

  const {data: response, isFetching: isLoadingPaymentListData} = Api.useGetQuery(
    '/analytics/zoho/payment/listview',
    {
      queryId: 'payment-list',
      filters,
      isCaching: true,
      isToast: false,
    }
  )

  const onApplyPaymentListFilters = (data: any) => {
    setMultipleFilters({
      store_filter: data.store !== '' ? data.store : '',
      supplier_filter: data.suppliers || '',
    })
  }

  const resetPaymentListFilters = () => {
    setMultipleFilters({
      store_filter: '',
      supplier_filter: '',
      search: '',
    })
  }
  return {
    paymentListData: response?.data || [],
    pagination: response?.pagination,
    isLoadingPaymentListData,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
    onApplyPaymentListFilters,
    resetPaymentListFilters,
  }
}

export default useGetPaymentListData
